import { useReducer, Dispatch, SetStateAction } from 'react';
import AccountBalance from './AccountBalance';
import PendingTransactions from './PendingTransactions';
import clsx from 'clsx';
import TransactionLog from './TransactionLog';
import Button from '../../../components/Button';
import { ChevronIcon } from '../../../assets/icons';
import useTransactionState from '../../../context/transaction/useTransactionState';
import SlippageSettings from './SlippageSettings';

type WalletDropdownContentProps = {
    renderSlippage: boolean;
    setRenderSlippage: Dispatch<SetStateAction<boolean>>;
};

const WalletDropdownContent: React.FC<WalletDropdownContentProps> = ({
    renderSlippage,
    setRenderSlippage,
}) => {
    const [isTxLogRendered, toggleTxLog] = useReducer((prev) => !prev, false);

    const { pendingTransactions } = useTransactionState();

    return (
        <div className='wallet-dropdown-content'>
            {renderSlippage ? (
                <SlippageSettings setRenderSlippage={setRenderSlippage} />
            ) : (
                <>
                    {!isTxLogRendered && (
                        <>
                            <AccountBalance />
                            <hr />
                        </>
                    )}
                    <div className='transaction-container'>
                        {isTxLogRendered ? <TransactionLog /> : <PendingTransactions />}
                        <div
                            className={clsx('transaction-container__bottom', {
                                'no-pending': !pendingTransactions.length,
                                single: pendingTransactions.length === 1,
                            })}
                        >
                            <div className='pending-count'>
                                {pendingTransactions.length} Pending
                            </div>
                            <Button
                                variant='transparent'
                                className={clsx({ back: isTxLogRendered })}
                                onClick={toggleTxLog}
                            >
                                {!isTxLogRendered && 'Transaction Log '}
                                <ChevronIcon />
                                {isTxLogRendered && 'Back'}
                            </Button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default WalletDropdownContent;
